import type { MyStudent } from "../api.js";
import { AccessibilityEditor } from "../AccessibilityEditor.js";
import {
  resetStudentAccessibilityPreferences,
  saveStudentAccessibilityPreferences,
  type StudentAccessibilityPreferences,
} from "../studentAccessibilityApi.js";

export interface AccessibilityProps {
  student: MyStudent;
  preferences: StudentAccessibilityPreferences;
  loading: boolean;
  loadError: string | null;
  onApplied: (preferences: StudentAccessibilityPreferences) => void;
  onReload: () => void;
}

/** Student-facing wrapper around the shared display-preference editor. */
export function Accessibility({
  student,
  preferences,
  loading,
  loadError,
  onApplied,
  onReload,
}: AccessibilityProps) {
  return (
    <>
      <h1>Accessibility</h1>
      <p className="lede">
        Adjust how the Hub looks for {student.isSelf ? "you" : student.fullName}. These settings
        only change how information is displayed.
      </p>

      <AccessibilityEditor
        preferences={preferences}
        loading={loading}
        loadError={loadError}
        onSave={async (next) =>
          (await saveStudentAccessibilityPreferences(student.id, next)).preferences
        }
        onReset={async () => (await resetStudentAccessibilityPreferences(student.id)).preferences}
        onApplied={onApplied}
        onReload={onReload}
      />
    </>
  );
}
